import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Najleto levis kapon el ŝuo por ekscii, kiel fartas lia Mastro, kaj tuj ekaŭdis: «Oj! Hu!»
    </p>
    
    <p class="mb-3">
      La Najleto maltrankviliĝis. 
      Verŝajne, la Mastron trafis iu plago? 
      Kaj la Najleto elŝoviĝis pli.
    </p>
    
    <p class="mb-3">
      - Oĥ! – ekkriis al Mastro, formetis la ŝuon kaj enmartelis la Najleton.
    </p>
    
    <p class="mb-3">
      - Li ion kaŝas de mi! – pensis la Najleto. 
      – Sed mi tamen malkovros la veron!
    </p>
    
    <p class="mb-3">
      Kaj li elŝoviĝis denove. 
      La Mastro koleriĝis, prenis tenajlon kaj eltrenis la Najleton. 
      Kuŝante inter rubo, la Najleto pensis:
    </p>
    
    <p class="mb-3">
      - Kia noblanima estas mia Mastro! Ne volas, ke aliuj vidu, kiel malbone li fartas!
    </p>
    `
  )
}

const itemName = {
  esp: 'Najleto'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;